import { getSlugsWithoutStep } from '@finn/ua-auth';
import { useParams, useSearchParams } from 'next/navigation';

export const useCheckoutParams = () => {
  const params = useParams();
  const searchParams = useSearchParams();

  return getSlugsWithoutStep(params?.slug || searchParams.get('slug'));
};
